import type { TranslationKey } from "./en";

const sw: Partial<Record<TranslationKey, string>> = {
  "lang.label": "Lugha",
  "lang.select": "Chagua lugha",
  "theme.toggle": "Badilisha mandhari",
  "theme.light": "Hali ya mwanga",
  "theme.dark": "Hali ya giza",
  "brand.name": "GuardAI na G-Data Labs",
  "brand.short": "GuardAI",
  "brand.subtitle": "Doria ya Usalama",
  "brand.guardSystem": "Mfumo wa Walinzi",
  "console.director": "Kibodi ya Mkurugenzi",
  "console.admin": "Kibodi ya Msimamizi Mkuu",
  "console.supervisor": "Kibodi ya Msimamizi",
  "role.administrator": "Msimamizi Mkuu",
  "role.director": "Mkurugenzi",
  "role.supervisor": "Msimamizi",
  "role.guard": "Mlinzi wa Usalama",
  "nav.dashboard": "Dashibodi",
  "nav.liveActivity": "Shughuli za Moja kwa Moja",
  "nav.devices": "Vifaa",
  "nav.schedules": "Ratiba",
  "nav.calendar": "Kalenda",
  "nav.alerts": "Tahadhari",
  "nav.checkpoints": "Vituo vya ukaguzi",
  "nav.reports": "Ripoti",
  "nav.reportBuilder": "Mtengenezaji wa Ripoti",
  "nav.askAi": "Uliza AI",
  "nav.admin": "Usimamizi",
  "nav.settings": "Mipangilio",
  "nav.deploy": "Tuma",
  "nav.scanMap": "Ramani ya Uchanganuzi",
  "nav.users": "Usimamizi wa Watumiaji",
  "common.save": "Hifadhi",
  "common.cancel": "Ghairi",
  "common.submit": "Wasilisha",
  "common.delete": "Futa",
  "common.edit": "Hariri",
  "common.search": "Tafuta",
  "common.filter": "Chuja",
  "common.export": "Hamisha",
  "common.clear": "Futa",
  "common.viewAll": "Tazama zote",
  "common.back": "Rudi",
  "common.close": "Funga",
  "common.confirm": "Thibitisha",
  "common.add": "Ongeza",
  "common.refresh": "Onyesha upya",
  "common.loading": "Inapakia…",
  "common.saving": "Inahifadhi…",
  "common.saved": "Imehifadhiwa",
  "common.error": "Hitilafu",
  "common.noData": "Hakuna data",
  "common.required": "Inahitajika",
  "common.optional": "Si lazima",
  "common.yes": "Ndiyo",
  "common.no": "Hapana",
  "common.all": "Zote",
  "common.none": "Hakuna",
  "common.name": "Jina",
  "common.status": "Hali",
  "common.location": "Mahali",
  "common.time": "Muda",
  "common.date": "Tarehe",
  "common.actions": "Vitendo",
  "common.today": "leo",
  "domain.scanEvent": "Tukio la uchanganuzi",
  "domain.scanEvents": "Matukio ya uchanganuzi",
  "domain.checkpoint": "Kituo cha ukaguzi",
  "domain.checkpoints": "Vituo vya ukaguzi",
  "domain.hospital": "Hospitali",
  "domain.hospitals": "Hospitali",
  "domain.guard": "Mlinzi",
  "domain.guards": "Walinzi",
  "domain.device": "Kifaa",
  "domain.devices": "Vifaa",
  "domain.patrol": "Doria",
  "domain.security": "Usalama",
  "domain.shift": "Zamu",
  "domain.station": "Kituo",
  "search.placeholder": "Tafuta walinzi, maeneo, au uchanganuzi…",
  "notif.title": "Arifa",
  "notif.empty": "Hakuna arifa mpya",
  "notif.viewAll": "Tazama Arifa Zote",
  "notif.missedCheckpoint": "Tahadhari ya Kituo Kilichokoswa",
  "status.active": "Hai",
  "status.inactive": "Si hai",
  "status.online": "Mtandaoni",
  "status.offline": "Nje ya mtandao",
  "status.pending": "Inasubiri",
  "status.approved": "Imeidhinishwa",
  "status.denied": "Imekataliwa",
  "status.flagged": "Imewekewa alama",
  "status.completed": "Imekamilika",
  "status.missed": "Imekoswa",
  "status.onDuty": "Kazini",
  "status.offDuty": "Nje ya Kazi",
  "auth.signIn": "Ingia",
  "auth.signingIn": "Inaingia…",
  "auth.signOut": "Toka",
  "auth.username": "Jina la mtumiaji",
  "auth.password": "Nenosiri",
  "auth.loginFailed": "Kuingia kumeshindwa",
  "auth.tagline": "Walinzi wa usalama huchanganua kitambulisho chao katika kituo chochote na wasimamizi huona masasisho papo hapo kwenye dashibodi salama.",
  "dashboard.title": "Kituo Kikuu cha Doria ya Usalama",
  "dashboard.subtitle": "Ufuatiliaji wa wakati halisi katika kila kituo cha ukaguzi",
  "dashboard.totalScans": "Jumla ya Uchanganuzi",
  "dashboard.activeGuards": "Walinzi Hai",
  "dashboard.checkpoints": "Vituo vya Ukaguzi",
  "dashboard.openAlerts": "Tahadhari Zilizo Wazi",
  "dashboard.recentActivity": "Shughuli za Hivi Karibuni",
  "dashboard.noActivity": "Hakuna shughuli za hivi karibuni",
  "live.title": "Shughuli za Doria za Moja kwa Moja",
  "live.subtitle": "Mtiririko wa wakati halisi wa kila uchanganuzi wa kitambulisho unapotokea",
  "live.empty": "Bado hakuna shughuli",
  "live.waiting": "Inasubiri uchanganuzi unaofuata…",
  "devices.title": "Vifaa vya Doria Vilivyounganishwa",
  "devices.subtitle": "Hali ya kila kifaa cha uchanganuzi kilicho uwandani",
  "devices.lastSeen": "Ilionekana mwisho",
  "devices.battery": "Betri",
  "devices.none": "Hakuna vifaa vilivyounganishwa",
  "schedules.title": "Ratiba za Doria",
  "schedules.subtitle": "Wapangie walinzi zamu na vituo vya ukaguzi",
  "schedules.addShift": "Ongeza Zamu",
  "schedules.none": "Bado hakuna ratiba",
  "alerts.title": "Tahadhari za Usalama",
  "alerts.subtitle": "Vituo vilivyokoswa na matukio yaliyowekewa alama yanayohitaji uangalifu",
  "alerts.none": "Hakuna tahadhari hai",
  "alerts.allClear": "Kila kitu kiko salama — hakuna kinachohitaji uangalifu.",
  "alerts.acknowledge": "Thibitisha kupokea",
  "alerts.resolve": "Tatua",
  "reports.title": "Ripoti za Usalama",
  "reports.subtitle": "Uchanganuzi wa ufunikaji wa doria, idadi ya uchanganuzi, na uadilifu",
  "reports.builderTitle": "Mtengenezaji wa Ripoti",
  "reports.builderSubtitle": "Buni ripoti za kitaalamu — hakuna uandishi wa msimbo unaohitajika.",
  "reports.generate": "Tengeneza Ripoti",
  "reports.noData": "Hakuna data ya ripoti hii",
  "ask.title": "Uliza AI",
  "ask.greeting": "Nawezaje kukusaidia leo?",
  "ask.placeholder": "Uliza chochote kuhusu doria zako, walinzi, au uchanganuzi…",
  "ask.send": "Tuma",
  "ask.thinking": "Inafikiri…",
  "admin.title": "Usimamizi wa Mfumo",
  "admin.subtitle": "Simamia ufikiaji, idhini, na afya ya mfumo",
  "admin.pendingApplications": "Maombi Yanayosubiri",
  "admin.systemHealth": "Afya ya Mfumo",
  "admin.uptime": "Muda wa Utendaji",
  "admin.storage": "Hifadhi",
  "admin.users": "Watumiaji",
  "admin.latency": "Ucheleweshaji",
  "users.title": "Usimamizi wa Watumiaji",
  "users.subtitle": "Ongeza, hariri, na zima akaunti za jukwaa",
  "users.addUser": "Ongeza Mtumiaji",
  "users.none": "Hakuna watumiaji waliopatikana",
  "settings.title": "Mipangilio",
  "settings.subtitle": "Simamia akaunti yako na mapendeleo",
  "settings.account": "Akaunti",
  "settings.appearance": "Mwonekano",
  "settings.notifications": "Arifa",
  "settings.language": "Lugha",
  "deploy.title": "Mpangaji wa Utumaji",
  "deploy.subtitle": "Panga, nasa, na thibitisha uwekaji wa vituo vya ukaguzi",
  "deploy.plan": "Panga",
  "deploy.capture": "Nasa",
  "deploy.verify": "Thibitisha",
  "map.title": "Ramani ya Uchanganuzi",
  "map.subtitle": "Mahali ambapo uchanganuzi wa vitambulisho unafanyika katika kituo chote",
  "map.noScans": "Hakuna uchanganuzi wa kuonyesha",
  "profile.account": "Akaunti",
  "profile.settings": "Mipangilio",
  "profile.help": "Usaidizi na Msaada",
  "profile.darkMode": "Hali ya Giza",
  "profile.viewProfile": "Tazama wasifu",
  "footer.copyright": "© 2026 G-Data Labs. Haki zote zimehifadhiwa.",
  "footer.terms": "Masharti ya Matumizi",
  "footer.privacy": "Sera ya Faragha",
  // ── Auto-added: full dashboard content translations ──
  "admin.addGuard": "Ongeza Mlinzi",
  "admin.addNewGuard": "Ongeza Mlinzi Mpya",
  "admin.addRoute": "Ongeza Njia",
  "admin.alertEmail": "Barua pepe ya Arifa za Tahadhari",
  "admin.avgResponse": "Wastani wa Majibu",
  "admin.checkpointTimeout": "Muda wa Kuisha wa Kituo cha Ukaguzi (dakika)",
  "admin.checkpointsCount": "Vituo vya Ukaguzi ({n})",
  "admin.colBadge": "Kitambulisho",
  "admin.colContact": "Mawasiliano",
  "admin.colGuard": "Mlinzi",
  "admin.colLastActive": "Shughuli ya Mwisho",
  "admin.colRole": "Jukumu",
  "admin.colRoutes": "Njia",
  "admin.deactivatedPreviewDesc": "Hivi ndivyo akaunti iliyozimwa inavyoonekana kwa wasimamizi.",
  "admin.deactivatedPreviewTitle": "Hakikisho la mlinzi aliyezimwa",
  "admin.difficultyEasy": "Rahisi",
  "admin.difficultyHard": "Ngumu",
  "admin.difficultyMedium": "Wastani",
  "admin.employeeId": "Kitambulisho cha Mfanyakazi:",
  "admin.errorAddGuard": "Imeshindwa kuongeza mlinzi. Tafadhali jaribu tena.",
  "admin.errorAllFields": "Sehemu zote zinahitajika.",
  "admin.errorLoadDirectory": "Imeshindwa kupakia orodha ya walinzi kwa sasa.",
  "admin.fieldEmail": "Barua pepe",
  "admin.fieldEmergencyContact": "Mtu wa Kuwasiliana Naye Dharura",
  "admin.fieldEmployeeId": "Kitambulisho cha Mfanyakazi cha Emory",
  "admin.fieldFullName": "Jina Kamili",
  "admin.fieldPhone": "Simu",
  "admin.fieldRole": "Jukumu",
  "admin.fieldTempPassword": "Nenosiri la Muda",
  "admin.gpsThreshold": "Kiwango cha Usahihi wa GPS (mita)",
  "admin.guardId": "Kitambulisho cha Mlinzi:",
  "admin.loadingDirectory": "Inapakia orodha ya walinzi…",
  "admin.moreCheckpoints": "+{n} vituo vya ukaguzi zaidi",
  "admin.noGuards": "Hakuna walinzi waliopatikana. Ongeza mlinzi wako wa kwanza ili kuanza.",
  "admin.noRoutesAssigned": "Hakuna njia zilizopangwa",
  "admin.notGenerated": "Haijatengenezwa",
  "admin.passwordPolicy": "Sera ya Nenosiri",
  "admin.passwordPolicyDesc": "Lazimisha manenosiri imara",
  "admin.patrolRoutes": "Njia za Doria",
  "admin.placeholderTempPassword": "Weka nenosiri la muda",
  "admin.resetSessions": "Weka Upya Vipindi Vyote",
  "admin.roleAdmin": "Msimamizi",
  "admin.roleDirector": "Mkurugenzi",
  "admin.roleGuard": "Mlinzi",
  "admin.roleSupervisor": "Msimamizi wa Eneo",
  "admin.saveConfiguration": "Hifadhi Usanidi",
  "admin.searchGuards": "Tafuta walinzi...",
  "admin.securitySettings": "Mipangilio ya Usalama",
  "admin.sessionTimeout": "Muda wa Kuisha wa Kipindi",
  "admin.sessionTimeoutDesc": "Kutoka kiotomatiki baada ya kutotumika",
  "admin.statusDeactivated": "Imezimwa",
  "admin.statusLabel": "Hali:",
  "admin.statusSuspended": "Imesimamishwa",
  "admin.storageUsed": "Hifadhi Iliyotumika",
  "admin.systemConfiguration": "Usanidi wa Mfumo",
  "admin.systemStatus": "Hali ya Mfumo",
  "admin.tabBadges": "Kitengeneza Vitambulisho",
  "admin.tabGuards": "Usimamizi wa Walinzi",
  "admin.tabRoutes": "Usimamizi wa Njia",
  "admin.tabSettings": "Mipangilio ya Mfumo",
  "admin.timeout1Hour": "Saa 1",
  "admin.timeout2Hours": "Saa 2",
  "admin.timeout30Min": "Dakika 30",
  "admin.timeout4Hours": "Saa 4",
  "admin.totalScans": "Jumla ya Skani",
  "admin.twoFactor": "Uthibitishaji wa Hatua Mbili",
  "admin.twoFactorDesc": "Hitaji 2FA kwa wasimamizi wote",
  "admin.viewBadge": "Tazama kitambulisho",
  "alerts.acknowledged": "Imethibitishwa",
  "alerts.activeAlerts": "Arifa zinazoendelea",
  "alerts.allLocationsHealthy": "Maeneo yote yako salama",
  "alerts.allPriorities": "Vipaumbele vyote",
  "alerts.allStatus": "Hali zote",
  "alerts.allTypes": "Aina zote",
  "alerts.apiError": "Hitilafu ya API",
  "alerts.assignedTo": "Imepewa:",
  "alerts.critical": "Hatari kubwa",
  "alerts.distanceAway": "umbali wa {n} m",
  "alerts.exportTitle": "Hamisha data ya arifa",
  "alerts.filters": "Vichujio",
  "alerts.guardLabel": "Mlinzi {name}",
  "alerts.high": "Juu",
  "alerts.invalidScan": "Skani batili",
  "alerts.issuesDetected": "Matatizo {n} yamegunduliwa",
  "alerts.loadFailed": "Imeshindwa kupakia arifa",
  "alerts.loadFailedHint": "hakikisha kituo cha arifa kimewekwa.",
  "alerts.loadingAlerts": "Inapakia arifa...",
  "alerts.low": "Chini",
  "alerts.medium": "Wastani",
  "alerts.noInvalidScans": "Hakuna skani batili katika kundi la hivi karibuni.",
  "alerts.noneMatchFilters": "Hakuna arifa zinazolingana na vichujio vyako",
  "alerts.refreshTitle": "Onyesha upya arifa",
  "alerts.resolved": "Imetatuliwa",
  "alerts.scanExceptions": "Hitilafu za skani za doria",
  "alerts.scanExceptionsSubtitle": "Skani batili au hitilafu za API zinazotoka kwa vifaa vya uwandani",
  "alerts.tryAgain": "Jaribu tena",
  "alerts.typeEmergency": "Dharura",
  "alerts.typeMissedCheckpoint": "Kituo cha ukaguzi kilichokoswa",
  "alerts.typeSystem": "Mfumo",
  "alerts.unknownGuard": "haijulikani",
  "ask.accessDenied": "Ufikiaji Umekataliwa",
  "ask.accessDeniedDesc": "Kipengele cha Uliza AI kimezuiwa kwa wasimamizi pekee.",
  "ask.askNow": "Uliza sasa",
  "ask.askedTimesOne": "Imeulizwa mara {n}",
  "ask.askedTimesOther": "Imeulizwa mara {n}",
  "ask.closeHistory": "Funga historia",
  "ask.dateAtTime": "{date} saa {time}",
  "ask.encryptedPrivate": "Uchambuzi Uliosimbwa na wa Faragha",
  "ask.errorMessage": "Samahani, sikuweza kushughulikia swali hilo. Hii inaweza kutokana na tatizo la muunganisho au hoja isiyoungwa mkono. Tafadhali jaribu kuandika upya swali lako au jaribu tena baadaye kidogo.",
  "ask.exampleInvalidScans": "Ni maeneo yapi yaliyorekodi skani BATILI nyingi zaidi wiki hii?",
  "ask.exampleMissedScans": "Nionyeshe walinzi waliokosa skani 3 au zaidi katika siku 7 zilizopita.",
  "ask.exampleNoScansToday": "Orodhesha maeneo ambayo hayajapokea skani yoyote leo.",
  "ask.exampleOvernightScans": "Skani ngapi zilirekodiwa usiku kati ya saa 22:00 na 06:00?",
  "ask.frequentlyAsked": "Maswali Yanayoulizwa Mara Kwa Mara",
  "ask.hideSql": "Ficha Hoja ya SQL",
  "ask.history": "Historia",
  "ask.inputPlaceholder": "Uliza kitu kama “Ni maeneo yapi yaliyokuwa na skani chache zaidi jana?”",
  "ask.noHistory": "Bado hakuna historia. Uliza swali ili kuanza.",
  "ask.noQueriesMatching": "Hakuna hoja zinazolingana na \"{q}\"",
  "ask.rowCountOne": "safu {n}",
  "ask.rowCountOther": "safu {n}",
  "ask.searchPlaceholder": "Tafuta hoja zilizopita...",
  "ask.showSql": "Onyesha Hoja ya SQL",
  "ask.subtitle": "Uliza kuhusu uzingatiaji wa doria, vituo vilivyokosa kuangaliwa, utendaji wa walinzi, au mienendo ya maeneo.",
  "ask.tagline": "Imejengwa kwa data ya doria ya wakati halisi",
  "ask.thisWeek": "Wiki Hii",
  "ask.today": "Leo",
  "ask.yesterday": "Jana",
  "auth.applyToJoin": "Omba kujiunga na timu yetu",
  "auth.email": "Barua pepe",
  "auth.enterCredentials": "Weka kitambulisho chako ili kufikia mfumo.",
  "auth.needAccess": "Unahitaji ufikiaji wa mfumo wa usalama?",
  "deploy.addFloor": "+ Ghorofa",
  "deploy.addUnplannedCheckpoint": "Ongeza Kituo cha Ukaguzi Kisichopangwa",
  "deploy.address": "Anwani",
  "deploy.allSaved": "Yote yamehifadhiwa",
  "deploy.area": "Eneo",
  "deploy.areaDescription": "Eneo / maelezo",
  "deploy.areaLabel": "Eneo:",
  "deploy.areaPlaceholder": "Mlango wa Dharura, Suite ya Utawala 200…",
  "deploy.areaSuite": "Eneo / Suite",
  "deploy.cameraError": "Hitilafu ya kamera:",
  "deploy.cancelScan": "Ghairi Uchanganuzi",
  "deploy.captureWalkthrough": "Ukaguzi wa Kunasa",
  "deploy.capturedProgress": "{done} / {total} zimenaswa",
  "deploy.checkpointsCount": "Vituo vya Ukaguzi ({n})",
  "deploy.ckStatusCaptured": "imenaswa",
  "deploy.ckStatusInstalled": "imesakinishwa",
  "deploy.ckStatusPlanned": "imepangwa",
  "deploy.ckStatusVerified": "imethibitishwa",
  "deploy.clickAnywhereToPlace": "Bofya popote kuweka alama",
  "deploy.clickFloorPlan": "Bofya ramani ya ghorofa…",
  "deploy.complete": "Imekamilika!",
  "deploy.completionReport": "Ripoti ya Kukamilika",
  "deploy.contactLabel": "Mawasiliano:",
  "deploy.contactPhone": "Simu ya Mawasiliano",
  "deploy.createAndCapture": "Unda na Unase",
  "deploy.createProject": "Unda Mradi",
  "deploy.creating": "Inaunda…",
  "deploy.dismiss": "ondoa",
  "deploy.editingCheckpoint": "Inahariri kituo cha ukaguzi",
  "deploy.fileFormats": "PNG, JPG, au PDF",
  "deploy.floor": "Ghorofa",
  "deploy.floorColon": "Ghorofa:",
  "deploy.floorLabel": "Ghorofa:",
  "deploy.floorN": "Ghorofa {n}",
  "deploy.floorPlanAlt": "Ramani ya ghorofa ya {n}",
  "deploy.generated": "Imetengenezwa:",
  "deploy.gettingGps": "Inapata GPS…",
  "deploy.gpsFailedRetry": "GPS imeshindwa — jaribu tena",
  "deploy.grabGps": "Pata GPS",
  "deploy.hospitalNameRequired": "Jina la Hospitali *",
  "deploy.initials": "Herufi za Mwanzo: ______",
  "deploy.installVerify": "Sakinisha na Thibitisha",
  "deploy.installedAlt": "imesakinishwa",
  "deploy.installedVerifiedProgress": "{done} / {total} zimesakinishwa na kuthibitishwa",
  "deploy.locationDetail": "Maelezo ya Mahali",
  "deploy.locationDetailPlaceholder": "Kushoto mwa milango mikuu, juu ya kisafisha mikono…",
  "deploy.locationDetailShort": "Kushoto mwa milango mikuu…",
  "deploy.locationLabel": "Mahali:",
  "deploy.markInstalledVerified": "Weka Alama Imesakinishwa na Kuthibitishwa",
  "deploy.newCheckpoint": "Kituo kipya cha ukaguzi",
  "deploy.newDeploymentProject": "Mradi Mpya wa Usambazaji",
  "deploy.newProject": "Mradi Mpya",
  "deploy.newUnplannedCheckpoint": "Kituo Kipya cha Ukaguzi Kisichopangwa",
  "deploy.noCameraFound": "Hakuna kamera iliyopatikana",
  "deploy.noCheckpointsHint": "Bofya \"Weka Alama\" kisha bofya kwenye ramani ya ghorofa.",
  "deploy.noCheckpointsYet": "Bado hakuna vituo vya ukaguzi.",
  "deploy.noProjectSelected": "Hakuna mradi uliochaguliwa",
  "deploy.noProjectSelectedHint": "Chagua mradi uliopo au unda mpya hapo juu.",
  "deploy.noProjectsYet": "Bado hakuna miradi.",
  "deploy.notYetVerified": "Bado Hazijathibitishwa",
  "deploy.notes": "Madokezo",
  "deploy.notesLabel": "Madokezo:",
  "deploy.notesPlaceholder": "Madokezo ya alama, maelezo ya usakinishaji…",
  "deploy.placeCardHere": "Weka kadi HAPA (kutoka kwa kunasa):",
  "deploy.placeMarker": "Weka Alama",
  "deploy.placementNotes": "Madokezo ya Uwekaji",
  "deploy.placementNotesPlaceholder": "Urefu wa futi 5, ukuta wa matofali, gundi ya kudumu…",
  "deploy.placementReferenceAlt": "marejeleo ya uwekaji",
  "deploy.print": "Chapisha",
  "deploy.printChecklist": "Chapisha Orodha ya Ukaguzi",
  "deploy.qrPlaced": "QR imewekwa",
  "deploy.qrPrefix": "QR:",
  "deploy.recapture": "Nasa Tena",
  "deploy.retakeInstalledPhoto": "Piga Picha ya Usakinishaji Tena",
  "deploy.retakePhoto": "Piga Picha Tena",
  "deploy.reverify": "Thibitisha Tena",
  "deploy.saveCapture": "Hifadhi Kunasa",
  "deploy.scanAgain": "Changanua Tena",
  "deploy.scanQrCode": "Changanua Msimbo wa QR",
  "deploy.scanToVerify": "Changanua ili Kuthibitisha",
  "deploy.scanVerified": "Uchanganuzi umethibitishwa",
  "deploy.scannedPrefix": "Imechanganuliwa:",
  "deploy.selectProject": "Chagua mradi…",
  "deploy.selectProjectShort": "Chagua mradi…",
  "deploy.selectProjectToCapture": "Chagua mradi ili kuanza kunasa.",
  "deploy.selectProjectToVerify": "Chagua mradi ili kuanza kuthibitisha.",
  "deploy.simulation3d": "Uigaji wa 3D",
  "deploy.siteContactName": "Jina la Mawasiliano ya Eneo",
  "deploy.speechNotSupported": "Utambuzi wa sauti hautumiki katika kivinjari hiki.",
  "deploy.statusCapturing": "kunasa",
  "deploy.statusComplete": "imekamilika",
  "deploy.statusFabricating": "kutengeneza",
  "deploy.statusInstalling": "kusakinisha",
  "deploy.statusPlanning": "kupanga",
  "deploy.stop": "Kituo",
  "deploy.stopNumber": "Kituo #{n}",
  "deploy.stopVoice": "Simamisha",
  "deploy.takeInstalledPhoto": "Piga Picha ya Usakinishaji",
  "deploy.takePhoto": "Piga Picha",
  "deploy.total": "Jumla",
  "deploy.unnamed": "Bila jina",
  "deploy.unnamedLower": "bila jina",
  "deploy.unsavedChanges": "Mabadiliko hayajahifadhiwa...",
  "deploy.uploadFloorPlan": "Pakia Ramani ya Ghorofa",
  "deploy.uploadFloorPlanFor": "Pakia ramani ya ghorofa kwa Ghorofa ya {n}",
  "deploy.uuidMatched": "UUID imefanana! QR imethibitishwa.",
  "deploy.uuidMismatch": "UUID hailingani. Kadi ya QR isiyo sahihi.",
  "deploy.uuidPrefix": "UUID:",
  "deploy.verifiedCheckpoints": "Vituo vya Ukaguzi Vilivyothibitishwa",
  "deploy.verifiedCount": "Zimethibitishwa",
  "deploy.voice": "Sauti",
  "deploy.walkthroughChecklistStops": "Orodha ya Ukaguzi ya Ukaguzi wa Usambazaji — vituo {n}",
  "devices.appVersion": "Toleo la Programu",
  "devices.deviceManagement": "Usimamizi wa Vifaa",
  "devices.emptyHint": "Vifaa vilivyounganishwa vitaonekana hapa mara vinapotuma telemetri.",
  "devices.geofences": "Mipaka ya Kijiografia",
  "devices.hoursAgo": "saa {n} zilizopita",
  "devices.justNow": "Sasa hivi",
  "devices.lastLocation": "Eneo la Mwisho",
  "devices.locateOnMap": "Tafuta Kifaa kwenye Ramani",
  "devices.minutesAgo": "dakika {n} zilizopita",
  "devices.never": "Kamwe",
  "devices.noDevicesFound": "Hakuna vifaa vilivyopatikana",
  "devices.noGpsData": "Hakuna data ya GPS",
  "devices.refreshStatus": "Onyesha Upya Hali",
  "devices.violations": "Ukiukaji",
  "geofence.acknowledge": "Kubali",
  "geofence.acknowledged": "Imekubaliwa",
  "geofence.acknowledging": "Inakubali...",
  "geofence.actionHeader": "Kitendo",
  "geofence.allGeofences": "Uzio Wote wa Kijiografia",
  "geofence.create": "Unda Uzio wa Kijiografia",
  "geofence.createdBy": "Imeundwa na",
  "geofence.createdDate": "Tarehe ya Kuundwa",
  "geofence.deleteConfirmBody": "Kitendo hiki hakiwezi kutenduliwa. Uzio wa kijiografia utafutwa kabisa.",
  "geofence.deleteConfirmTitle": "Futa Uzio wa Kijiografia?",
  "geofence.drawPolygon": "Chora Pembewili kwenye Ramani",
  "geofence.drawPolygonHint": "Bofya kwenye ramani kuongeza pointi. Pembewili lazima iwe na angalau pointi 3. Pointi za sasa: {n}",
  "geofence.edit": "Hariri Uzio wa Kijiografia",
  "geofence.enterName": "Tafadhali ingiza jina la uzio wa kijiografia",
  "geofence.failedCreate": "Imeshindwa kuunda uzio wa kijiografia",
  "geofence.failedDelete": "Imeshindwa kufuta uzio wa kijiografia",
  "geofence.failedLoad": "Imeshindwa kupakia uzio wa kijiografia",
  "geofence.failedSave": "Imeshindwa kuhifadhi uzio wa kijiografia",
  "geofence.failedUpdate": "Imeshindwa kusasisha uzio wa kijiografia",
  "geofence.filterByGeofence": "Chuja kwa Uzio wa Kijiografia",
  "geofence.geofenceHeader": "Uzio wa Kijiografia",
  "geofence.gpsCoordinates": "Viwianishi vya GPS",
  "geofence.hoursAgo": "saa {n} zilizopita",
  "geofence.justNow": "Sasa hivi",
  "geofence.management": "Usimamizi wa Uzio wa Kijiografia",
  "geofence.managementSubtitle": "Bainisha kanda salama na fuatilia ukiukaji wa mipaka",
  "geofence.minPoints": "Pembewili lazima iwe na angalau pointi 3",
  "geofence.minutesAgo": "dakika {n} zilizopita",
  "geofence.nameLabel": "Jina la Uzio wa Kijiografia",
  "geofence.namePlaceholder": "k.m., Mlango Mkuu, Maegesho A",
  "geofence.noViolations": "Hakuna ukiukaji uliogunduliwa",
  "geofence.noViolationsHint": "Vifaa vyote viko ndani ya uzio wa kijiografia uliopangwa.",
  "geofence.noneConfigured": "Hakuna uzio wa kijiografia uliosanidiwa kwa eneo lako.",
  "geofence.noneYet": "Bado hakuna uzio wa kijiografia",
  "geofence.noneYetCanCreate": "Unda uzio wako wa kwanza wa kijiografia ili kuanza ufuatiliaji wa mipaka.",
  "geofence.pointN": "Pointi {n}:",
  "geofence.polygonPoints": "Pointi za Pembewili ({n})",
  "geofence.preview": "Hakiki",
  "geofence.save": "Hifadhi Uzio wa Kijiografia",
  "geofence.selectHospitalAlert": "Tafadhali chagua hospitali",
  "geofence.selectHospitalOption": "Chagua hospitali...",
  "geofence.unacknowledged": "Haijakubaliwa",
  "geofence.unacknowledgedCount": "{n} hazijakubaliwa",
  "geofence.violationsSubtitle": "Fuatilia na kubali ukiukaji wa mipaka",
  "geofence.violationsTitle": "Ukiukaji wa Uzio wa Kijiografia",
  "help.callNow": "Piga simu sasa",
  "help.comingSoon": "Inakuja hivi karibuni",
  "help.docsComingSoon": "Nyaraka zinakuja hivi karibuni.",
  "help.emailSupport": "Msaada kwa barua pepe",
  "help.escalateIssue": "Pandisha tatizo",
  "help.guardHeadline": "Usaidizi na msaada wa walinzi",
  "help.guidesFaq": "Miongozo na maswali yanayoulizwa mara kwa mara",
  "help.incidentEscalation": "Upandishaji wa tukio",
  "help.incidentEscalationDesc": "Ripoti kukatika kwa huduma, hitilafu za kioski, au matatizo ya dharura ya uchanganuzi.",
  "help.intro": "Wasiliana na timu ya Doria ya Usalama ya Emory au kagua hatua za haraka za utatuzi.",
  "help.phoneHotline": "Simu ya dharura",
  "help.phoneHotlineValue": "(404) 555-0199 • Saa 24 / Siku 7",
  "help.quickTips": "Vidokezo vya haraka",
  "help.sendEmail": "Tuma barua pepe",
  "help.supervisorHeadline": "Usaidizi na msaada wa wasimamizi",
  "help.support": "Msaada",
  "help.tipAskAi": "Tumia ukurasa wa Uliza AI kupata data ya kihistoria kabla ya kuwasiliana na msaada.",
  "help.tipRefresh": "Onyesha upya ukurasa ikiwa uchanganuzi unaonekana kuchelewa au wa zamani.",
  "help.tipReinstall": "Walinzi wanaweza kusakinisha tena PWA kupitia ukurasa wa Mipangilio wakati aikoni inapotoweka.",
  "home.activeCheckpoints": "Vituo vya Ukaguzi Vinavyofanya Kazi",
  "home.activeCheckpointsTooltip": "Jumla ya maeneo halisi ya msimbo wa QR yaliyosajiliwa kwa sasa katika hospitali hii.",
  "home.addNewMarker": "Ongeza Kialamisho Kipya",
  "home.allHospitalsAggregated": "Hospitali Zote (Zilizojumlishwa)",
  "hospitals.allAggregated": "Hospitali Zote (Zilizojumlishwa)",
  "home.building": "Jengo",
  "home.buildingFloor": "{building} - Ghorofa {floor}",
  "home.cancelPlacement": "Ghairi Uwekaji",
  "home.chartScans": "Michanganuo:",
  "home.checkpointName": "Jina la Kituo cha Ukaguzi",
  "home.checkpointNamePlaceholder": "k.m. Fedha (Magharibi)",
  "home.checkpointsScanned": "Vituo vya Ukaguzi Vilivyochanganuliwa",
  "home.chooseCheckpoint": "— Chagua kituo cha ukaguzi —",
  "home.cleared": "IMEIDHINISHWA",
  "home.clickToPlace": "Bofya mahali popote kwenye ramani ili kuweka kialamisho kipya.",
  "home.comparingScanVolume": "Kulinganisha kiasi cha michanganuo inayoendelea katika maeneo yote yaliyosajiliwa",
  "home.complianceRate": "Kiwango cha Uzingatiaji",
  "home.complianceRateTooltip": "Asilimia ya vituo vya ukaguzi vilivyosajiliwa ambavyo vimechanganuliwa angalau mara moja wakati wa zamu ya sasa.",
  "home.complianceRateValue": "Kiwango cha Uzingatiaji: {n}%",
  "home.confirmDeleteCheckpoint": "Una uhakika unataka kufuta kituo hiki cha ukaguzi? Kitendo hiki hakiwezi kutenduliwa.",
  "home.createCustomCheckpoint": "+ Unda kituo maalum cha ukaguzi...",
  "home.deleteMarker": "Futa Kialamisho",
  "home.dragToReposition": "Buruta vialamisho ili kuvipanga upya. Mabadiliko huhifadhiwa kiotomatiki.",
  "home.editModeOn": "Hali ya Kuhariri IMEWASHWA",
  "home.editPositions": "Hariri Nafasi",
  "home.failedDeleteLocation": "Imeshindwa kufuta eneo",
  "home.failedSaveLocation": "Imeshindwa kuhifadhi eneo",
  "home.floor": "Ghorofa",
  "home.floorAbbr": "Gh. {n}",
  "home.floorN": "Ghorofa {n}",
  "home.headerSubtitle": "Uthibitishaji wa doria kwa wakati halisi na hali ya upakiaji wa kitovu",
  "home.hospitalPerformanceComparison": "Ulinganisho wa Utendaji wa Hospitali",
  "home.hospitalSecurity": "Usalama wa Hospitali",
  "home.hub": "Kitovu: {hub}",
  "home.internalServerError": "Hitilafu ya Ndani ya Seva",
  "home.lastHour": "Saa Iliyopita",
  "home.lastScan": "Mchanganuo wa Mwisho",
  "home.lastUpdated": "Imesasishwa mwisho:",
  "home.legendError": "Hitilafu",
  "home.legendInvalid": "Batili",
  "home.legendOk": "Sawa",
  "home.liveSystem": "Mfumo wa Moja kwa Moja",
  "home.loadingCheckpoints": "Inapakia vituo vya ukaguzi...",
  "home.loadingComplianceData": "Inapakia data ya uzingatiaji...",
  "home.loadingUploads": "Inapakia upakiaji...",
  "home.mapLast30Days": "Siku 30 Zilizopita",
  "home.mapLast7Days": "Siku 7 Zilizopita",
  "home.mapLastQuarter": "Robo Iliyopita",
  "home.mapSubtitle": "Ufuatiliaji wa doria kwa wakati halisi na hali ya vituo vya ukaguzi",
  "home.mapTitle": "Ramani ya Shughuli za Moja kwa Moja za Hospitali",
  "home.mapTodaysScans": "Michanganuo ya Leo",
  "home.moreCheckpoints": "+ vituo {n} zaidi vya ukaguzi",
  "home.noCheckpointsConfigured": "Hakuna vituo vya ukaguzi vilivyosanidiwa kwa hospitali hii.",
  "home.noCheckpointsLoaded": "Hakuna vituo vya ukaguzi vilivyopakiwa. Kagua muunganisho wa hifadhidata au ongeza kimoja mwenyewe hapa chini.",
  "home.noUploadsToday": "Hakuna upakiaji uliorekodiwa leo.",
  "home.numberOfScans": "Idadi ya Michanganuo",
  "home.pendingClear": "INASUBIRI KUIDHINISHWA",
  "home.placeCheckpoint": "Weka Kituo cha Ukaguzi",
  "home.positionLabel": "Nafasi:",
  "home.qrPayload": "Mzigo wa QR",
  "home.qrPayloadPlaceholder": "k.m. FINANCE_WEST",
  "home.recentPatrolActivity7Days": "Shughuli za Doria za Hivi Karibuni (siku&nbsp;7)",
  "home.recentScans7Days": "Michanganuo ya Hivi Karibuni (siku&nbsp;7)",
  "home.recentScansTooltip": "Jumla ya michanganuo ya doria iliyopakiwa na kuthibitishwa kwa mafanikio katika siku 7 zilizopita.",
  "home.registeredCheckpoints": "Vituo vya Ukaguzi Vilivyosajiliwa",
  "home.roleDashboard": "Dashibodi ya {role}:",
  "home.saveCheckpoint": "Hifadhi Kituo cha Ukaguzi",
  "home.scanner": "Kichanganuzi: {serial}",
  "home.scansCount": "michanganuo {n}",
  "home.selectCheckpoint": "Chagua Kituo cha Ukaguzi",
  "home.tooltipPosition": "Nafasi",
  "home.unknownHospital": "Hospitali Isiyojulikana",
  "home.uploadsByShift": "Upakiaji kwa Zamu",
  "home.viewingHospital": "Hospitali Inayotazamwa:",
  "landing.addressInfo": "Taarifa za Anwani",
  "landing.agreeTerms": "Ninakubali masharti ya huduma",
  "landing.agreeTermsDetail": "Ninaelewa kuwa ufikiaji wa mfumo wa doria za usalama unategemea idhini ya msimamizi na kwamba taarifa zote zilizotolewa ni sahihi na kamili.",
  "landing.availableShifts": "Zamu Zinazopatikana (chagua zote zinazohusika)",
  "landing.bulletIntegrity": "Uchanganuzi wa uadilifu kwa skani zilizokoswa na matukio yaliyowekewa alama.",
  "landing.bulletMonitoring": "Ufuatiliaji wa wakati halisi kwa kila ukumbi, lango na ukanda.",
  "landing.bulletWorkspace": "Eneo-kazi lililounganishwa la msimamizi lenye utafutaji wa papo hapo na maarifa ya AI.",
  "landing.city": "Jiji",
  "landing.completeAndAgree": "Tafadhali kamilisha sehemu zote zinazohitajika na ukubali masharti.",
  "landing.confirmPassword": "Thibitisha Nenosiri",
  "landing.confirmYourPassword": "Thibitisha nenosiri lako",
  "landing.createPassword": "Tengeneza nenosiri salama",
  "landing.dateOfBirth": "Tarehe ya Kuzaliwa",
  "landing.emailAddress": "Anwani ya Barua Pepe",
  "landing.emailRegistered": "Anwani hii ya barua pepe tayari imesajiliwa.",
  "landing.emailRegisteredUseDifferent": "Anwani hii ya barua pepe tayari imesajiliwa. Tafadhali tumia anwani tofauti ya barua pepe.",
  "landing.emergencyContact": "Mtu wa Kuwasiliana Naye Dharura",
  "landing.emergencyContactName": "Jina la Mtu wa Kuwasiliana Naye Dharura",
  "landing.emergencyContactPhone": "Simu ya Mtu wa Kuwasiliana Naye Dharura",
  "landing.fillRequiredContinue": "Tafadhali jaza sehemu zote zinazohitajika kabla ya kuendelea.",
  "landing.firstName": "Jina la Kwanza",
  "landing.lastName": "Jina la Ukoo",
  "landing.next": "Endelea",
  "landing.passwordsNoMatch": "Manenosiri hayalingani",
  "landing.percentComplete": "Imekamilika {p}%",
  "landing.personalInfo": "Taarifa Binafsi",
  "landing.phoneNumber": "Namba ya Simu",
  "landing.phoneRegistered": "Namba hii ya simu tayari imesajiliwa.",
  "landing.phoneRegisteredUseDifferent": "Namba hii ya simu tayari imesajiliwa. Tafadhali tumia namba tofauti ya simu.",
  "landing.relChild": "Mtoto",
  "landing.relFriend": "Rafiki",
  "landing.relOther": "Nyingine",
  "landing.relParent": "Mzazi",
  "landing.relSibling": "Ndugu",
  "landing.relSpouse": "Mwenzi wa Ndoa",
  "landing.relationship": "Uhusiano",
  "landing.requestAccessSubtitle": "Jaza fomu hii ili kuomba ufikiaji wa mfumo wa doria za usalama.",
  "landing.requestAccessTitle": "Omba Ufikiaji wa Mfumo",
  "landing.requestSubmitted": "Ombi la Akaunti Limewasilishwa",
  "landing.requestSubmittedApproval": "Utaweza kuingia kwa kitambulisho chako mara baada ya kuidhinishwa. Mchakato huu huchukua siku 1-2 za kazi kwa kawaida.",
  "landing.requestSubmittedThanks": "Asante kwa kuomba ufikiaji wa mfumo wa doria za usalama. Ombi lako limewasilishwa na linasubiri kuidhinishwa na wasimamizi.",
  "landing.requestedRole": "Jukumu Lililoombwa",
  "landing.returnHome": "Rudi Mwanzo",
  "landing.returnToLogin": "Rudi kwenye Kuingia",
  "landing.roleAvailability": "Jukumu na Upatikanaji",
  "landing.securityDirector": "Mkurugenzi wa Usalama",
  "landing.securitySupervisor": "Msimamizi wa Usalama",
  "landing.selectEllipsis": "Chagua...",
  "landing.shiftDay": "Zamu ya Mchana (saa 12 asubuhi - saa 8 mchana)",
  "landing.shiftEvening": "Zamu ya Jioni (saa 8 mchana - saa 4 usiku)",
  "landing.shiftHolidays": "Sikukuu",
  "landing.shiftNight": "Zamu ya Usiku (saa 4 usiku - saa 12 asubuhi)",
  "landing.shiftOnCall": "Kwa Wito",
  "landing.shiftWeekends": "Wikendi",
  "landing.signInSubheading": "Tumia kitambulisho chako cha msimamizi au mlinzi ili kuendelea.",
  "landing.signInToGuard": "Ingia kwenye Guard",
  "landing.somethingWrong": "Hitilafu fulani imetokea.",
  "landing.state": "Jimbo",
  "landing.stepOf": "Hatua ya {n} kati ya 4",
  "landing.streetAddress": "Anwani ya Mtaa",
  "landing.submitApplication": "Wasilisha Ombi",
  "landing.submitFailed": "Imeshindwa kuwasilisha ombi. Tafadhali jaribu tena.",
  "landing.submitting": "Inawasilisha...",
  "landing.termsOfService": "Masharti ya Huduma",
  "landing.zipCode": "Msimbo wa Posta",
  "live.action": "Kitendo",
  "live.activityFeed": "Mtiririko wa shughuli",
  "live.asOf": "Kufikia {time}",
  "live.colCoordinate": "Kuratibu",
  "live.colDateTime": "Tarehe na saa",
  "live.colDistance": "Umbali",
  "live.deviceLocation": "(Mahali pa Kifaa)",
  "live.filterAll": "Shughuli zote",
  "live.filterInvalid": "Skani batili",
  "live.filterValid": "Skani halali",
  "live.floor": "Ghorofa {n}",
  "live.freshFix": "(Eneo Jipya)",
  "live.loadingActivity": "Inapakia shughuli ya doria…",
  "live.metersAway": "umbali wa mita {n}",
  "live.noGpsData": "Hakuna data ya GPS",
  "live.noScansFilter": "Hakuna skani zinazolingana na kichujio hiki.",
  "live.syncData": "Sawazisha Data",
  "live.timeframe": "Kipindi cha muda",
  "live.unknownHospital": "Hospitali isiyojulikana",
  "live.unknownLocation": "Mahali pasipojulikana",
  "live.view3d": "Mwonekano wa 3D",
  "live.view3dWorld": "Tazama ulimwengu wa 3D wa kituo hiki",
  "map.allHospitals": "Hospitali zote",
  "map.autoRefresh": "Onyesha upya kiotomatiki",
  "map.autoRefreshTitle": "Onyesha upya kiotomatiki kila sekunde 30",
  "map.dark": "Giza",
  "map.expandLegend": "Panua ufafanuzi",
  "map.gpsDisclaimer": "Nafasi za skani zinaonyesha usahihi wa GPS ya kifaa. Ishara za ndani zinaweza kutofautiana kwa mita 10–50 kutoka mahali halisi.",
  "map.heatmap": "Ramani ya joto",
  "map.heatmapTitle": "Washa/zima ramani ya joto ya msongamano",
  "map.legend": "Ufafanuzi",
  "map.light": "Angavu",
  "map.limitedWarning": "Ramani inaonyesha hadi skani {max} kwa kiwango cha juu. Tafadhali punguza kipindi cha muda au kichujio cha hospitali ili kuona data mahususi.",
  "map.loadFailed": "Imeshindwa kupakia skani",
  "map.loadingScans": "Inapakia skani…",
  "map.mapStyle": "Mtindo wa ramani: {name}",
  "map.markers": "Vialamisho",
  "map.minimizeLegend": "Punguza ufafanuzi",
  "map.noGpsScans": "Hakuna skani zenye lebo ya GPS zilizopatikana kwa kipindi hiki cha muda.",
  "map.pageSubtitle": "Mwonekano wa kijiografia wa moja kwa moja wa mahali matukio ya skani yalipotokea.",
  "map.pageTitle": "Ramani ya Skani ya GuardAI",
  "map.popupHospital": "Hospitali:",
  "map.popupScanner": "Skana:",
  "map.popupTime": "Muda:",
  "map.rangeCustom": "Kipindi maalum",
  "map.rangeLast24h": "Saa 24 zilizopita",
  "map.rangeLast30d": "Siku 30 zilizopita",
  "map.rangeLast7d": "Siku 7 zilizopita",
  "map.rangeLastHour": "Saa iliyopita",
  "map.showingMaxScans": "Inaonyesha {shown} (kiwango cha juu) kati ya skani {total}",
  "map.snapToBuilding": "Pangilia kwenye jengo",
  "map.snapToBuildingTitle": "Pangilia nukta za GPS kuelekea vituo vya majengo ili kukabiliana na mwendokasi wa GPS wa ndani",
  "map.switchToDark": "Badilisha kwenda ramani giza",
  "map.switchToLight": "Badilisha kwenda ramani angavu",
  "map.to": "hadi",
  "map.totalScans": "Skani {total}",
  "map.unknownHospital": "Haijulikani",
  "map.updatedAt": "Imesasishwa {time}",
  "reportBuilder.addWidget": "Ongeza wijeti",
  "reportBuilder.aiAssistant": "Msaidizi wa ripoti wa AI",
  "reportBuilder.aiPlaceholder": "Eleza ripoti unayotaka — k.m. “idadi ya skani kwa kila hospitali kwa mwezi uliopita ikiwa na chati ya pau.” Au chora muundo kwenye karatasi na upakie picha.",
  "reportBuilder.aiSummaryHint": "Bofya “Tengeneza” ili kuandika uchunguzi kutoka kwa data ya ripoti yako.",
  "reportBuilder.allHospitals": "Hospitali zote",
  "reportBuilder.allTime": "Wakati wote",
  "reportBuilder.assistantUnavailable": "Msaidizi haupatikani kwa sasa.",
  "reportBuilder.author": "Mwandishi",
  "reportBuilder.beta": "Beta",
  "reportBuilder.buildItForMe": "Nitengenezee",
  "reportBuilder.buildTogether": "Tujengeni pamoja",
  "reportBuilder.canvasEmpty": "Turubai yako haina chochote",
  "reportBuilder.canvasEmptyHint": "Ongeza wijeti kutoka kwenye upau wa zana hapo juu, bofya uga wa data upande wa kushoto, au anza kutoka kwa kiolezo.",
  "reportBuilder.captionPlaceholder": "Maelezo (hiari)",
  "reportBuilder.color": "Rangi",
  "reportBuilder.compareAgainst": "Linganisha na",
  "reportBuilder.configure": "Sanidi",
  "reportBuilder.copySuffix": "(nakala)",
  "reportBuilder.couldntSave": "Imeshindwa kuhifadhi:",
  "reportBuilder.dataFields": "Sehemu za data",
  "reportBuilder.dataFieldsHint": "Bofya uga wowote ili kuongeza wijeti iliyotengenezwa tayari kwenye ripoti yako.",
  "reportBuilder.dataSource": "Chanzo cha data",
  "reportBuilder.dateFrom": "Kuanzia {date}",
  "reportBuilder.dateFromLabel": "Tarehe kuanzia",
  "reportBuilder.dateThrough": "Hadi {date}",
  "reportBuilder.dateToLabel": "Tarehe hadi",
  "reportBuilder.dayOfWeekOpt": "Siku ya wiki",
  "reportBuilder.describeOrSketch": "Eleza ripoti unayotaka, au ambatisha mchoro.",
  "reportBuilder.dismiss": "Ondoa",
  "reportBuilder.done": "Imekamilika",
  "reportBuilder.donutStyle": "Mtindo wa pete",
  "reportBuilder.draftedOffline": " · imeandaliwa nje ya mtandao",
  "reportBuilder.duplicate": "Nakili",
  "reportBuilder.example1": "Idadi ya skani kwa kila hospitali kwa mwezi uliopita, ikiwa na chati ya pau",
  "reportBuilder.example2": "Shughuli za doria za kila siku zikiwa na saa za kilele na vifaa vinavyotumika",
  "reportBuilder.example3": "Ufikiaji wa vituo vya ukaguzi: vilivyoskaniwa dhidi ya visivyoskaniwa kwa kila hospitali",
  "reportBuilder.exportCsv": "CSV (data)",
  "reportBuilder.exportFailed": "Uhamishaji umeshindwa:",
  "reportBuilder.exportHtml": "HTML (inayoshirikika)",
  "reportBuilder.exportPdf": "PDF (tayari kuchapishwa)",
  "reportBuilder.exportPng": "Picha ya PNG",
  "reportBuilder.exportPrint": "Chapisha",
  "reportBuilder.exportSlides": "Tayari kwa slaidi (HTML)",
  "reportBuilder.exportTryPdf": "Jaribu PDF (Chapisha) badala yake.",
  "reportBuilder.exportXls": "Excel (.xls)",
  "reportBuilder.fieldTitle": "Kichwa",
  "reportBuilder.filterFloor": "Chuja: ghorofa",
  "reportBuilder.filterHospital": "Chuja: hospitali",
  "reportBuilder.floorPlaceholder": "k.m. L1, 5, Plaza",
  "reportBuilder.generate": "Tengeneza",
  "reportBuilder.generateBtn": "Tengeneza",
  "reportBuilder.generatedBy": "Imetengenezwa na GuardAI · © {year} G-Data Labs. Haki zote zimehifadhiwa.",
  "reportBuilder.generating": "Inatengeneza…",
  "reportBuilder.group": "Kikundi",
  "reportBuilder.groupBy": "Panga kwa",
  "reportBuilder.hideSettings": "Ficha mipangilio",
  "reportBuilder.horizontal": "mlalo",
  "reportBuilder.imageTooLarge": "Picha hiyo ni kubwa kidogo — tafadhali tumia yenye chini ya MB 6.",
  "reportBuilder.imageUrlPlaceholder": "URL ya picha (hiari)",
  "reportBuilder.includeLogo": "Jumuisha nembo ya GuardAI",
  "reportBuilder.loadFailed": "Imeshindwa kupakia data.",
  "reportBuilder.lookAt": "Angalia {target}",
  "reportBuilder.maxRows": "Safu za juu zaidi",
  "reportBuilder.metric": "Kipimo",
  "reportBuilder.moreSettings": "Mipangilio zaidi",
  "reportBuilder.moveDown": "Sogeza chini",
  "reportBuilder.moveUp": "Sogeza juu",
  "reportBuilder.next": "Endelea",
  "reportBuilder.noDataSelection": "Hakuna data kwa chaguo hili",
  "reportBuilder.noImageUploaded": "Hakuna picha iliyopakiwa",
  "reportBuilder.noLayout": "Sikuweza kuibadilisha kuwa muundo — jaribu kueleza vipimo na jinsi ya kuvipanga.",
  "reportBuilder.noSummary": "Hakuna muhtasari uliotengenezwa.",
  "reportBuilder.noWidgetsYet": "Ripoti hii bado haina wijeti.",
  "reportBuilder.optionalSubtitle": "Kichwa kidogo cha hiari",
  "reportBuilder.orientation": "Mwelekeo",
  "reportBuilder.period": "Kipindi: {range}",
  "reportBuilder.preparedBy": "Imeandaliwa na {name}",
  "reportBuilder.preview": "Hakiki",
  "reportBuilder.previewHint": "Hivi ndivyo ripoti yako itakavyohamishwa na kuchapishwa. Tumia kitufe cha Hamisha hapo juu kupakua.",
  "reportBuilder.regenerate": "Tengeneza upya",
  "reportBuilder.remove": "Ondoa",
  "reportBuilder.removeImage": "Ondoa picha",
  "reportBuilder.reportImage": "Picha ya ripoti",
  "reportBuilder.reportTitle": "Kichwa cha ripoti",
  "reportBuilder.reportsAnalytics": "Ripoti na Uchanganuzi",
  "reportBuilder.saveAsTemplate": "Hifadhi ripoti ya sasa kama kiolezo cha pamoja",
  "reportBuilder.savedAt": "Imehifadhiwa saa {time}",
  "reportBuilder.savedReports": "Ripoti zilizohifadhiwa",
  "reportBuilder.secondSeriesLabel": "Lebo ya mfululizo wa pili",
  "reportBuilder.secondSeriesMetric": "Kipimo cha mfululizo wa pili",
  "reportBuilder.secondSeriesSource": "Chanzo cha mfululizo wa pili",
  "reportBuilder.selectWidget": "Chagua wijeti ili kuisanidi.",
  "reportBuilder.seriesB": "Mfululizo B",
  "reportBuilder.sketch": "Mchoro",
  "reportBuilder.sketchAlt": "mchoro",
  "reportBuilder.sort": "Panga",
  "reportBuilder.sortLabelAsc": "Jina, A → Z",
  "reportBuilder.sortLabelDesc": "Jina, Z → A",
  "reportBuilder.sortValueAsc": "Thamani, chini → juu",
  "reportBuilder.sortValueDesc": "Thamani, juu → chini",
  "reportBuilder.startFromTemplate": "Anza kutoka kwa kiolezo",
  "reportBuilder.startNewReport": "Anza ripoti mpya",
  "reportBuilder.stepOf": "Hatua {n} kati ya {total}",
  "reportBuilder.subtitle": "Kichwa kidogo",
  "reportBuilder.summaryFailed": "Imeshindwa kutengeneza muhtasari.",
  "reportBuilder.targetAiBar": "upau wa msaidizi wa AI",
  "reportBuilder.targetCanvas": "turubai ya ripoti",
  "reportBuilder.targetConfigPanel": "paneli ya kusanidi",
  "reportBuilder.targetDataFields": "paneli ya sehemu za data",
  "reportBuilder.targetExport": "kitufe cha kuhamisha",
  "reportBuilder.targetPreview": "swichi ya hakiki",
  "reportBuilder.targetSave": "kitufe cha kuhifadhi",
  "reportBuilder.targetTemplates": "kitufe cha violezo",
  "reportBuilder.targetToolbar": "upau wa zana wa wijeti",
  "reportBuilder.templates": "Violezo",
  "reportBuilder.textPlaceholder": "Andika maandishi yako. Tumia ## kwa kichwa na **bold** kwa msisitizo.",
  "reportBuilder.thinking": "Inafikiria…",
  "reportBuilder.title": "Kitengeneza Ripoti",
  "reportBuilder.total": "Jumla",
  "reportBuilder.try": "Jaribu:",
  "reportBuilder.untitledReport": "Ripoti Isiyo na Kichwa",
  "reportBuilder.uploadSketchTitle": "Pakia picha ya muundo wa ripoti uliochorwa kwa mkono",
  "reportBuilder.vertical": "wima",
  "reportBuilder.walkMeThrough": "Nielekeze hatua kwa hatua",
  "reportBuilder.widgetCountMany": "wijeti {n}",
  "reportBuilder.widgetCountOne": "wijeti {n}",
  "reportBuilder.width": "Upana",
  "reportBuilder.widthFull": "Kamili",
  "reportBuilder.working": "Inafanya kazi…",
  "reports.activeGuards": "Walinzi Hai",
  "reports.asOfTime": "(hadi {time})",
  "reports.averageCompliance": "Wastani wa Uzingatiaji",
  "reports.averageResponseTime": "Wastani wa Muda wa Kujibu",
  "reports.checkpointLocationAnalysis": "Uchambuzi wa Maeneo ya Vituo",
  "reports.checkpointsCompleted": "Vituo Vilivyokamilika",
  "reports.checkpointsLoggedGps": "(vituo {n} vimeandikwa kutoka data ya GPS)",
  "reports.colCompliance": "Uzingatiaji",
  "reports.colPerformance": "Utendaji",
  "reports.compliance90to94": "Uzingatiaji 90-94%",
  "reports.compliance95": "Uzingatiaji ≥95%",
  "reports.complianceBelow90": "Uzingatiaji <90%",
  "reports.complianceLabel": "uzingatiaji",
  "reports.complianceReport": "Ripoti ya Uzingatiaji",
  "reports.coverageComplianceHelp": "% ya vituo vilivyotembelewa angalau mara moja katika kipindi hiki",
  "reports.coverageComplianceTrends": "Mwelekeo wa Uzingatiaji wa Ufikiaji",
  "reports.criticalIssuesResolved": "Masuala Muhimu Yaliyotatuliwa",
  "reports.currentTime": "Sasa: {time}",
  "reports.dayFri": "Iju",
  "reports.dayFriday": "Ijumaa",
  "reports.dayMon": "Jtt",
  "reports.dayMonday": "Jumatatu",
  "reports.daySat": "Jmo",
  "reports.daySaturday": "Jumamosi",
  "reports.daySun": "Jpi",
  "reports.daySunday": "Jumapili",
  "reports.dayThu": "Alh",
  "reports.dayThursday": "Alhamisi",
  "reports.dayTue": "Jnn",
  "reports.dayTuesday": "Jumanne",
  "reports.dayWed": "Jtn",
  "reports.dayWednesday": "Jumatano",
  "reports.deltaLastMonth": "+1.8% kutoka mwezi uliopita",
  "reports.deltaLastQuarter": "+3.2% kutoka robo iliyopita",
  "reports.deltaLastWeek": "+2.1% kutoka wiki iliyopita",
  "reports.deltaYesterday": "+1.5% kutoka jana",
  "reports.downloadReport": "Pakua Ripoti",
  "reports.exceptions": "Hitilafu",
  "reports.exportFormat": "Muundo wa Kuhamisha",
  "reports.exportReport": "Hamisha Ripoti",
  "reports.guardPerformanceAnalysis": "Uchambuzi wa Utendaji wa Walinzi",
  "reports.heatmapCellTitle": "{location} - {label}: {pct}% shughuli",
  "reports.lessActivity": "Shughuli Chache",
  "reports.loadingPatrolActivity": "Inapakia shughuli za doria…",
  "reports.locationAbbreviations": "Vifupisho vya Maeneo:",
  "reports.locationActivityHeatmap": "Ramani ya Joto ya Shughuli za Maeneo",
  "reports.missedCheckpoints": "Vituo Vilivyokoswa",
  "reports.missedCount": "{n} vilivyokoswa",
  "reports.monFeb": "Feb",
  "reports.monJan": "Jan",
  "reports.monMar": "Mac",
  "reports.monthN": "Mwezi {n}",
  "reports.moreActivity": "Shughuli Nyingi",
  "reports.noChange": "Hakuna mabadiliko",
  "reports.noCoverageData": "Bado hakuna data ya ufikiaji",
  "reports.noDataForPeriod": "Hakuna data kwa kipindi",
  "reports.noScanLocations": "Hakuna maeneo ya kuskani msimbo wa QR yanayopatikana",
  "reports.notAvailable": "Haipatikani",
  "reports.overallComplianceRate": "Kiwango cha Jumla cha Uzingatiaji",
  "reports.patrolLocations": "Maeneo ya doria",
  "reports.periodMonth": "Mwezi Huu",
  "reports.periodQuarter": "Robo Hii",
  "reports.periodToday": "Leo",
  "reports.periodWeek": "Wiki Hii",
  "reports.popupCompliance": "Uzingatiaji:",
  "reports.popupLast": "Mwisho:",
  "reports.popupScans": "Skani:",
  "reports.qrScanLocations": "Maeneo ya Kuskani QR",
  "reports.quickExportOptions": "Chaguo za Kuhamisha Haraka",
  "reports.realScanData": "Data halisi ya skani (saa 24 zilizopita)",
  "reports.scanToSeeLocations": "Skani misimbo ya QR ili kuona maeneo kwenye ramani",
  "reports.scansCount": "skani {n}",
  "reports.scansThisMonth": "skani {n} mwezi huu",
  "reports.scansThisQuarter": "skani {n} robo hii",
  "reports.scansThisWeek": "skani {n} wiki hii",
  "reports.scansToday": "skani {n} leo",
  "reports.tabCompliance": "Uzingatiaji",
  "reports.tabGuardPerformance": "Utendaji wa Walinzi",
  "reports.tabLocationAnalysis": "Uchambuzi wa Maeneo",
  "reports.tabOverview": "Muhtasari",
  "reports.totalScans": "Jumla ya skani",
  "reports.trackingLocationsGuards": "Inafuatilia maeneo {locations} na walinzi {guards}.",
  "reports.trendDaily": "Mwelekeo wa Utendaji wa Kila Siku",
  "reports.trendHourly": "Mwelekeo wa Utendaji kwa Saa",
  "reports.trendMonthly": "Mwelekeo wa Utendaji wa Kila Mwezi",
  "reports.trendTooltip": "{pct}% (maeneo {n})",
  "reports.trendWeekly": "Mwelekeo wa Utendaji wa Kila Wiki",
  "reports.validated": "Imethibitishwa",
  "reports.viewDetails": "Tazama Maelezo",
  "reports.weekN": "Wiki {n}",
  "reports.weeklySummary": "Muhtasari wa Wiki",
  "reports.wk1": "Wk1",
  "reports.wk2": "Wk2",
  "reports.wk3": "Wk3",
  "reports.wk4": "Wk4",
  "schedules.activeRoutes": "Njia Zinazotumika",
  "schedules.activeSchedules": "Ratiba Zinazoendelea",
  "schedules.addNewSchedule": "Ongeza Ratiba Mpya",
  "schedules.addSchedule": "Ongeza Ratiba",
  "schedules.assignedGuard": "Mlinzi Aliyepangwa",
  "schedules.assignedGuards": "Walinzi Waliopangwa",
  "schedules.calendar": "Kalenda",
  "schedules.confirmDelete": "Una uhakika unataka kufuta ratiba hii?",
  "schedules.coverageGaps": "Mapengo ya Ufikiaji",
  "schedules.createSchedule": "Unda Ratiba",
  "schedules.dayFri": "Iju",
  "schedules.dayMon": "Jtt",
  "schedules.daySat": "Jmo",
  "schedules.daySun": "Jpi",
  "schedules.dayThu": "Alh",
  "schedules.dayTue": "Jnn",
  "schedules.dayWed": "Jtn",
  "schedules.daysOfWeek": "Siku za Wiki",
  "schedules.deleteSchedule": "Futa Ratiba",
  "schedules.editSchedule": "Hariri Ratiba",
  "schedules.endTime": "Saa ya Kumaliza",
  "schedules.fillRequired": "Tafadhali jaza sehemu zote zinazohitajika",
  "schedules.frequency": "Marudio",
  "schedules.frequencyCustom": "Maalum",
  "schedules.frequencyDaily": "Kila Siku",
  "schedules.frequencyWeekly": "Kila Wiki",
  "schedules.listView": "Mwonekano wa Orodha",
  "schedules.morningPatrol": "Doria ya Asubuhi",
  "schedules.nightShift": "Zamu ya Usiku",
  "schedules.route": "Njia",
  "schedules.scheduleName": "Jina la Ratiba",
  "schedules.scheduleNamePlaceholder": "k.m., Doria ya Asubuhi - Jengo A",
  "schedules.selectGuard": "Chagua mlinzi",
  "schedules.selectRoute": "Chagua njia",
  "schedules.selectedCount": "Imechaguliwa: vituo {n} vya ukaguzi",
  "schedules.startTime": "Saa ya Kuanza",
  "schedules.updateSchedule": "Sasisha Ratiba",
  "settings.browserDesc": "UA imerekodiwa kufuatilia uadilifu wa kifaa.",
  "settings.browserLabel": "Kivinjari",
  "settings.cameraDesc": "Inahitajika kuchanganua lebo za QR. Rekebisha katika mipangilio ya mfumo ikiwa imekataliwa.",
  "settings.cameraPermission": "Ruhusa ya kamera",
  "settings.deviceIdDesc": "Alama ya kidole huhifadhiwa kwa kila uchanganuzi kwa ajili ya uzingatiaji wa ukaguzi.",
  "settings.deviceIdLabel": "Kitambulisho cha kifaa",
  "settings.email": "Barua pepe",
  "settings.escalationAlerts": "Arifa za upandishaji",
  "settings.fullName": "Jina kamili",
  "settings.installPwa": "Sakinisha kama PWA",
  "settings.locationDesc": "Inahitajika kwa uthibitishaji wa GPS katika kila kituo cha ukaguzi.",
  "settings.locationPermission": "Ruhusa ya eneo",
  "settings.mobilePhone": "Simu ya mkononi",
  "settings.notRegistered": "Bado hakijasajiliwa",
  "settings.notificationDesc": "Dhibiti ni arifa zipi timu ya wasimamizi inaweza kukutumia.",
  "settings.notificationPreferences": "Mapendeleo ya arifa",
  "settings.permGranted": "Imeruhusiwa",
  "settings.permUnknown": "Haijulikani",
  "settings.profileDetails": "Maelezo ya wasifu",
  "settings.profileSavedMsg": "Mapendeleo ya wasifu yamehifadhiwa. Mabadiliko yanaanza kutumika mara moja.",
  "settings.pwaAndroid": "Android (Chrome):",
  "settings.pwaAndroidSteps": "Menyu → Sakinisha Programu.",
  "settings.pwaDesktop": "Kompyuta ya mezani:",
  "settings.pwaDesktopSteps": "Tumia kidirisha cha usakinishaji cha kivinjari kwenye upau wa anwani.",
  "settings.pwaIos": "iOS (Safari):",
  "settings.pwaIosSteps": "Gusa Shiriki → Ongeza kwenye Skrini ya Mwanzo.",
  "settings.saveProfile": "Hifadhi wasifu",
  "settings.storedLocally": "Mipangilio huhifadhiwa kwenye kifaa hadi usawazishaji wa wasifu utakapopatikana.",
  "settings.weeklyEmailSummary": "Muhtasari wa wiki kwa barua pepe",
  "users.applicationDetails": "Maelezo ya Ombi",
  "users.applicationReview": "Ukaguzi wa Ombi:",
  "users.applicationStatus": "Hali ya Ombi",
  "users.approve": "Idhinisha",
  "users.approveApplication": "Idhinisha Ombi",
  "users.backToApplications": "Rudi kwa Maombi",
  "users.colApplicant": "Mwombaji",
  "users.colRole": "Jukumu",
  "users.dateAdded": "Tarehe ya kuongezwa",
  "users.directoryFound": "Imepatikana katika jedwali la employees_personal_info.",
  "users.directoryMatch": "Ulinganifu wa orodha",
  "users.directoryName": "Jina la orodha",
  "users.email": "Barua pepe",
  "users.filterAll": "Maombi Yote",
  "users.filterPending": "Inasubiri Ukaguzi",
  "users.nextSteps": "Hatua Zinazofuata",
  "users.noApplications": "Hakuna maombi yaliyopatikana",
  "users.phone": "Simu",
  "users.phoneNumber": "Nambari ya simu",
  "users.reject": "Kataa",
  "users.rejectApplication": "Kataa Ombi",
  "users.requestedRole": "Jukumu lililoombwa",
  "users.review": "Kagua",
  "users.statusRejected": "Imekataliwa",
  "users.stepBackgroundCheck": "Anzisha ukaguzi wa historia",
  "users.stepCheckLicense": "Angalia uhalali wa leseni/cheti",
  "users.stepScheduleInterview": "Panga mahojiano ikiwa imeidhinishwa",
  "users.stepVerifyReferences": "Thibitisha marejeleo kwa simu",
  "users.submitted": "Imewasilishwa:",
  "widget.aiSummary": "Muhtasari wa AI",
  "widget.barChart": "Chati ya Pau",
  "widget.comparison": "Ulinganisho",
  "widget.dataTable": "Jedwali la Data",
  "widget.dayOfWeek": "Siku ya Wiki",
  "widget.image": "Picha",
  "widget.kpiRow": "Safu ya KPI",
  "widget.lineChart": "Chati ya Mistari",
  "widget.metricCard": "Kadi ya Kipimo",
  "widget.pieDonut": "Duara / Pete",
  "widget.rankedTable": "Jedwali Lililopangwa",
  "widget.textBlock": "Kizuizi cha Maandishi",

  // Activity calendar
  "calendar.title": "Kalenda ya shughuli za doria",
  "calendar.subtitle": "Shughuli za uchanganuzi katika kila kituo, siku kwa siku",
  "calendar.viewMonth": "Mwezi",
  "calendar.viewWeek": "Wiki",
  "calendar.viewDay": "Siku",
  "calendar.viewList": "Orodha",
  "calendar.today": "Leo",
  "calendar.allHospitals": "Hospitali zote",
  "calendar.totalScans": "Michanganuo {n}",
  "calendar.activeDays": "Siku {n} zenye shughuli",
  "calendar.alertsCount": "Tahadhari {n}",
  "calendar.noActivityRange": "Hakuna shughuli za uchanganuzi katika kipindi hiki.",
  "calendar.loading": "Inapakia shughuli…",
  "calendar.loadFailed": "Imeshindwa kupakia shughuli",
  "calendar.refresh": "Onyesha upya",
  "calendar.colTime": "Saa",
  "calendar.colHospital": "Hospitali",
  "calendar.colCheckpoint": "Kituo",
  "calendar.colDevice": "Kifaa",
  "calendar.colGuard": "Mlinzi",
  "calendar.violation": "Ukiukaji",
  "calendar.violationsCount": "Ukiukaji {n}",
  "calendar.scansShort": "Michanganuo {n}",
  "calendar.hospitalsActive": "Hospitali {n} zinazoendelea",
  "calendar.moreEvents": "+{n} zaidi",
  "calendar.weekOf": "Wiki ya {date}",
  "calendar.dayEvents": "Matukio ya uchanganuzi",
  "calendar.hourlyDistribution": "Mgawanyo wa kila saa",
  "calendar.legendLess": "Chache",
  "calendar.legendMore": "Nyingi",
  "calendar.unknownHospital": "Hospitali isiyojulikana",
  "calendar.unknownGuard": "Mlinzi asiyejulikana",
  "calendar.unknownCheckpoint": "Kituo kisichojulikana",

  // --- Synced from en.ts: newer pages (officers, compliance, checkpoints, patrol reports) ---
  "nav.compliance": "Uzingatiaji",
  "nav.officers": "Maofisa",
  "nav.patrolReports": "Ripoti za Doria",
  "common.retry": "Jaribu tena",
  "common.collapse": "Kunja",
  "common.expand": "Panua",
  "home.comparisonVsMapNote": "Hesabu hujumuisha kila skani iliyorekodiwa. Ramani ya Skani huonyesha skani zenye viwianishi vya GPS pekee, kwa hivyo jumla yake inaweza kuwa ndogo zaidi.",
  "live.colOfficer": "Afisa",
  "live.unattributed": "Haijahusishwa",
  "map.trailNote": "Nukta zimepakwa rangi kulingana na muda wa skani. Hakuna njia inayochorwa kati ya skani — maeneo ya skani yaliyorekodiwa pekee ndiyo yanayoonyeshwa.",
  "checkpoints.directoryTitle": "Orodha ya Vituo vya Ukaguzi",
  "checkpoints.directorySubtitle": "Kila kituo cha ukaguzi cha QR kilichosajiliwa, kimepangwa kwa ghorofa",
  "checkpoints.searchPlaceholder": "Tafuta kwa jina, msimbo, au jengo…",
  "checkpoints.countShown": "vituo {n} vya ukaguzi",
  "checkpoints.exportCsv": "Hamisha CSV",
  "checkpoints.loadingDirectory": "Inapakia vituo vya ukaguzi…",
  "checkpoints.empty": "Hakuna vituo vya ukaguzi vilivyopatikana kwa hospitali hii.",
  "checkpoints.noFloor": "Haijapangiwa",
  "checkpoints.floorLabel": "Ghorofa {n}",
  "checkpoints.colCode": "Msimbo",
  "checkpoints.colName": "Jina",
  "checkpoints.colBuilding": "Jengo",
  "checkpoints.colFloor": "Ghorofa",
  "checkpoints.colLastScanned": "Skani ya Mwisho",
  "checkpoints.colTotalScans": "Jumla ya Skani",
  "checkpoints.colStatus": "Hali",
  "checkpoints.active": "Hai",
  "checkpoints.inactive": "Si hai",
  "checkpoints.never": "Kamwe",
  "checkpoints.untitled": "Kituo cha Ukaguzi Kisicho na Jina",
  "checkpoints.totalScans": "Jumla ya Skani",
  "checkpoints.compliance": "Uzingatiaji",
  "checkpoints.late": "Imechelewa",
  "checkpoints.missed": "Imekoswa",
  "checkpoints.fromDate": "Kuanzia",
  "checkpoints.toDate": "Hadi",
  "checkpoints.clearDates": "Futa",
  "checkpoints.loadingHistory": "Inapakia historia ya skani…",
  "checkpoints.noScans": "Hakuna skani zilizorekodiwa kwa kituo hiki cha ukaguzi katika kipindi kilichochaguliwa.",
  "checkpoints.unknownDevice": "Kifaa kisichojulikana",
  "checkpoints.noGps": "Hakuna GPS",
  "checkpoints.statusOnTime": "Kwa wakati",
  "checkpoints.statusLate": "Imechelewa",
  "checkpoints.statusMissed": "Imekoswa",
  "checkpoints.viewHistory": "Tazama historia ya skani",
  "compliance.title": "Uzingatiaji wa Doria",
  "compliance.subtitle": "Hali ya skani za vituo vya ukaguzi dhidi ya kipindi kilichowekwa cha kila eneo.",
  "compliance.advisory": "Kwa taarifa tu. Mwonekano huu unaripoti wakati kila kituo cha ukaguzi kilipochanganuliwa mara ya mwisho na muda uliobaki katika kipindi chake cha skani. Si mgawo wa kazi, njia, wala maagizo. Ni vituo vya ukaguzi vipi vinavyoskaniwa na kwa mpangilio upi hubaki uamuzi wa afisa na msimamizi wake, kwa kuzingatia maagizo ya kazi ya mwajiri wao na majukumu yoyote ya kipaumbele cha juu zaidi.",
  "compliance.loadFailed": "Imeshindwa kupakia hali ya uzingatiaji",
  "compliance.overdue": "Imepitwa na Muda",
  "compliance.overdueSub": "Imepita kipindi cha skani",
  "compliance.dueSoon": "Inakaribia Kupita Muda",
  "compliance.dueSoonSub": "Katika robo ya mwisho ya kipindi",
  "compliance.onInterval": "Ndani ya Kipindi",
  "compliance.onIntervalSub": "Imechanganuliwa ndani ya kipindi",
  "compliance.neverScanned": "Hakuna Skani Iliyorekodiwa",
  "compliance.neverScannedSub": "Haihesabiwi kama iliyopitwa na muda",
  "compliance.neverScannedNoteTitle": "Kwa nini hizi hazihesabiwi kama zilizopitwa na muda:",
  "compliance.neverScannedNote": "Kituo cha ukaguzi kisicho na skani iliyorekodiwa hakina kipindi cha kuwa kimekipita. Vituo vya ukaguzi vilivyokuwepo kabla ya ufuatiliaji wa uzingatiaji husomeka hivi hadi ujazaji wa data ya kihistoria uendeshwe kwa eneo, kwa hivyo kuvihesabu kama vilivyopitwa na muda kungeleta tahadhari kwa kila kituo cha ukaguzi kwa wakati mmoja.",
  "compliance.openAlerts": "Tahadhari za Uzingatiaji Zilizo Wazi",
  "compliance.checkpointStatus": "Hali ya Kituo cha Ukaguzi",
  "compliance.filterAttention": "Zilizopitwa na muda na zinazokaribia",
  "compliance.filterOverdue": "Zilizopitwa na muda pekee",
  "compliance.filterAll": "Vituo vyote vya ukaguzi",
  "compliance.emptyAll": "Hakuna vituo vya ukaguzi vilivyopatikana kwa uchaguzi huu.",
  "compliance.emptyAttention": "Hakuna vituo vya ukaguzi vilivyopitwa na muda au vinavyokaribia kupita.",
  "compliance.colCheckpoint": "Kituo cha Ukaguzi",
  "compliance.colStatus": "Hali",
  "compliance.colLastScan": "Skani ya mwisho",
  "compliance.colInterval": "Kipindi",
  "compliance.colRemaining": "Muda katika kipindi",
  "compliance.colScans24h": "Skani (saa 24)",
  "compliance.status.OVERDUE": "Imepitwa na Muda",
  "compliance.status.DUE_SOON": "Inakaribia Kupita Muda",
  "compliance.status.OK": "Ndani ya Kipindi",
  "compliance.status.NEVER_SCANNED": "Hakuna Skani Iliyorekodiwa",
  "compliance.minutesShort": "dak",
  "compliance.perDay": "kwa siku",
  "compliance.ruleLocation": "kanuni ya eneo",
  "compliance.ruleHospital": "chaguo-msingi la eneo",
  "compliance.truncated": "Inaonyesha matokeo yanayozingatia muda zaidi pekee. Punguza kwa eneo ili kuona mengine.",
  "compliance.generatedAt": "Hali kufikia",
  "compliance.rules": "Vipindi vya Skani",
  "compliance.rulesTitle": "Vipindi vya Skani",
  "compliance.rulesSubtitle": "Kanuni ya eneo hushinda chaguo-msingi la eneo, ambalo hushinda chaguo-msingi la mfumo.",
  "compliance.rulesEmpty": "Hakuna kanuni maalum — chaguo-msingi la mfumo linatumika.",
  "compliance.rulesLoadFailed": "Imeshindwa kupakia kanuni",
  "compliance.rulesSaveFailed": "Imeshindwa kuhifadhi kanuni",
  "compliance.rulesDeleteFailed": "Imeshindwa kufuta kanuni",
  "compliance.rulesCreateFailed": "Imeshindwa kuunda kanuni",
  "compliance.rulesInvalid": "Kipindi na kiwango cha chini cha kila siku lazima viwe namba",
  "compliance.systemDefault": "Chaguo-msingi la mfumo",
  "compliance.systemDefaultValue": "kila",
  "compliance.systemDefaultNote": "Maeneo yasiyo na kanuni yao yenyewe hupimwa dhidi ya hili.",
  "compliance.siteWide": "Vituo vyote vya ukaguzi katika eneo hili",
  "compliance.colAppliesTo": "Inatumika kwa",
  "compliance.colIntervalMin": "Kipindi (dak)",
  "compliance.colMinPerDay": "Kiwango cha chini / saa 24",
  "compliance.colActions": "Vitendo",
  "compliance.addSiteDefault": "Ongeza chaguo-msingi la eneo",
  "compliance.pickSiteToAdd": "Chagua eneo moja ili kuongeza chaguo-msingi kwa ajili yake.",
  "officers.title": "Maofisa",
  "officers.subtitle": "Maofisa wanaoingia kazini kwa namba ya N ili skani zao zihusishwe nao. Hawa si watumiaji wa kuingia kwenye dashibodi.",
  "officers.add": "Ongeza afisa",
  "officers.addTitle": "Ongeza afisa",
  "officers.editTitle": "Hariri afisa",
  "officers.loadFailed": "Imeshindwa kupakia maofisa",
  "officers.saveFailed": "Imeshindwa kuhifadhi afisa",
  "officers.deactivateFailed": "Imeshindwa kuzima afisa",
  "officers.searchPlaceholder": "Tafuta kwa jina, namba ya N au barua pepe",
  "officers.filterActive": "Hai",
  "officers.filterInactive": "Si hai",
  "officers.filterSuspended": "Imesimamishwa",
  "officers.filterPending": "Inasubiri idhini",
  "officers.filterRejected": "Imekataliwa",
  "officers.filterAll": "Hali zote",
  "officers.onShiftCount": "Waliopo kazini sasa:",
  "officers.empty": "Bado hakuna maofisa. Ongeza mmoja ili kuanza kuhusisha skani.",
  "officers.emptySearch": "Hakuna maofisa wanaolingana na utafutaji huo.",
  "officers.colOfficer": "Afisa",
  "officers.colNNumber": "Namba ya N",
  "officers.colSite": "Eneo",
  "officers.colStatus": "Hali",
  "officers.colShift": "Zamu ya sasa",
  "officers.colActions": "Vitendo",
  "officers.status.ACTIVE": "Hai",
  "officers.status.PENDING": "Inasubiri idhini",
  "officers.status.INACTIVE": "Si hai",
  "officers.status.SUSPENDED": "Imesimamishwa",
  "officers.status.REJECTED": "Imekataliwa",
  "officers.onShiftSince": "Kazini tangu",
  "officers.offShift": "Hayupo kazini",
  "officers.scans": "skani",
  "officers.deactivate": "Zima",
  "officers.deactivateTitle": "Zima afisa?",
  "officers.deactivateBody": "{name} hataweza tena kuingia kazini, na zamu yoyote iliyo wazi itafungwa. Historia yake ya skani huhifadhiwa na inabaki ikihusishwa naye.",
  "officers.fieldNNumber": "Namba ya N",
  "officers.fieldNNumberHint": "Herufi N ya mwanzo huongezwa kiotomatiki ukiiacha.",
  "officers.fieldName": "Jina kamili",
  "officers.fieldSite": "Eneo",
  "officers.fieldEmail": "Barua pepe",
  "officers.fieldPhone": "Simu",
  "officers.fieldStatus": "Hali",
  "officers.fieldStatusHint": "Maofisa walio HAI pekee ndio wanaoweza kuingia kazini. Kubadilisha kutoka HAI hufunga zamu yoyote iliyo wazi.",
  "officers.selectSite": "Chagua eneo",
  "officers.formRequired": "Namba ya N, jina na eneo vinahitajika",
  "officers.pendingTitle": "Idhini za usajili zinazosubiri",
  "officers.selfEnrolled": "Alijisajili mwenyewe",
  "officers.enrolledAt": "aliingia kazini",
  "officers.enrollDistance": "{d} kutoka kanda ya skani iliyorekodiwa ya eneo",
  "officers.enrollNoGps": "hakuna GPS wakati wa kuingia kazini",
  "officers.enrollSiteMismatch": "Ilichaguliwa {chosen}, lakini GPS ilielekeza {gps} — thibitisha lipi ni sahihi kabla ya kuidhinisha.",
  "officers.pendingNote": "Vitambulisho hivi vilijitangaza wakati wa skani ya kitambulisho. Skani zao huhusishwa kwa muda hadi zitakapoidhinishwa; kukataa huhifadhi rekodi na skani zake kwa ukaguzi.",
  "officers.approve": "Idhinisha",
  "officers.reject": "Kataa",
  "officers.approveTitle": "Idhinisha usajili?",
  "officers.approveBody": "Inathibitisha {n} kama afisa katika {site}. Skani zake zinazosubiri zinabaki zikihusishwa naye na kuingia kazini kwa siku zijazo kunafanya kazi kama kawaida.",
  "officers.approveName": "Jina la afisa (kama linavyopaswa kuonekana)",
  "officers.approveFailed": "Imeshindwa kuidhinisha usajili",
  "officers.rejectFailed": "Imeshindwa kukataa usajili",
  "patrolReports.title": "Ripoti za Doria",
  "patrolReports.subtitle": "Shughuli za doria zilizorekodiwa kwa afisa, ufikiaji wa vituo vya ukaguzi, na historia ya tahadhari za uzingatiaji.",
  "patrolReports.tabOfficers": "Maofisa",
  "patrolReports.tabCoverage": "Ufikiaji",
  "patrolReports.tabHistory": "Historia ya Tahadhari",
  "patrolReports.loadFailed": "Imeshindwa kupakia ripoti",
  "patrolReports.badRange": "Tarehe ya kuanza lazima iwe sawa na au kabla ya tarehe ya mwisho",
  "patrolReports.startDate": "Tarehe ya kuanza",
  "patrolReports.endDate": "Tarehe ya mwisho",
  "patrolReports.totalScans": "Skani katika Kipindi",
  "patrolReports.attributed": "Zimehusishwa na Afisa",
  "patrolReports.unattributed": "Hazijahusishwa",
  "patrolReports.unattributedSub": "Zilizoskaniwa wakati hakuna afisa aliyekuwa kazini",
  "patrolReports.officersListed": "Maofisa Walioorodheshwa",
  "patrolReports.noOfficers": "Hakuna maofisa katika uchaguzi huu.",
  "patrolReports.colOfficer": "Afisa",
  "patrolReports.colSite": "Eneo",
  "patrolReports.colShifts": "Zamu",
  "patrolReports.colShiftTime": "Muda wa zamu",
  "patrolReports.colScans": "Skani",
  "patrolReports.colCheckpoints": "Vituo vya ukaguzi",
  "patrolReports.colScansHr": "Skani / saa",
  "patrolReports.colLastScan": "Skani ya mwisho",
  "patrolReports.fullyCovered": "Zimefikiwa Kila Siku",
  "patrolReports.partiallyCovered": "Zimefikiwa Baadhi ya Siku",
  "patrolReports.uncovered": "Hakuna Skani katika Kipindi",
  "patrolReports.of": "kati ya",
  "patrolReports.coverageTitle": "Ufikiaji wa Vituo vya Ukaguzi",
  "patrolReports.coverageSort": "Vituo vya ukaguzi vilivyofikiwa kidogo zaidi kwanza.",
  "patrolReports.colCheckpoint": "Kituo cha Ukaguzi",
  "patrolReports.colDaysCovered": "Siku zilizofikiwa",
  "patrolReports.colExpected": "Inayotarajiwa",
  "patrolReports.colStatusNow": "Hali sasa",
  "patrolReports.alertsRaised": "Tahadhari katika Kipindi",
  "patrolReports.alertsOpen": "Bado Ziko Wazi",
  "patrolReports.alertsResolved": "Zimetatuliwa",
  "patrolReports.repeatTitle": "Vituo vya Ukaguzi Vinavyoleta Tahadhari Mara Nyingi Zaidi",
  "patrolReports.colAlerts": "Tahadhari",
  "patrolReports.colOpen": "Wazi",
  "patrolReports.colWorst": "Iliyopitwa na muda zaidi",
  "patrolReports.colAvgResolve": "Wastani wa kutatua",
  "patrolReports.colLatest": "Ya hivi karibuni",
  "patrolReports.alertLog": "Kumbukumbu ya Tahadhari",
  "patrolReports.noAlerts": "Hakuna tahadhari katika kipindi hiki.",
  "patrolReports.resolvedIn": "imetatuliwa ndani ya",
  "patrolReports.stateResolved": "Imetatuliwa",
  "patrolReports.stateOpen": "Wazi",
  "emailPrefs.title": "Mapendeleo ya Tahadhari za Barua Pepe",
  "emailPrefs.subtitle": "Chagua barua pepe zipi za uzingatiaji unazopokea, kwa kila eneo.",
  "emailPrefs.loadFailed": "Imeshindwa kupakia mapendeleo ya barua pepe",
  "emailPrefs.saveFailed": "Imeshindwa kuhifadhi pendeleo",
  "emailPrefs.noSites": "Hakuna maeneo katika orodha yako ya ufikiaji.",
  "emailPrefs.noPreference": "Hakuna pendeleo lililohifadhiwa — chaguo mbadala linatumika",
  "emailPrefs.explainer": "Maeneo ambayo hakuna aliyehifadhi pendeleo hurejea kutuma barua pepe kwa wasimamizi na wakurugenzi wote. Kuhifadhi pendeleo lolote katika eneo hubadilisha hilo kuwa machaguo yaliyobainishwa pekee.",
  "emailPrefs.overdue": "Tahadhari za kupitwa na muda",
  "emailPrefs.overdueHint": "Barua pepe ya papo hapo vituo vya ukaguzi vinapopita kipindi chao cha skani",
  "emailPrefs.daily": "Muhtasari wa kila siku",
  "emailPrefs.dailyHint": "Muhtasari mmoja wa uzingatiaji kwa siku",
  "emailPrefs.officerSummary": "Muhtasari wa shughuli za afisa",
  "emailPrefs.officerSummaryHint": "Ripoti ya kila wiki ya shughuli zilizorekodiwa. Imezimwa isipokuwa ujiandikishe.",
  "emailPrefs.manageOthers": "Simamia wapokeaji katika eneo hili",
  "emailPrefs.noOthers": "Hakuna wapokeaji wengine waliosanidiwa hapa.",
  "emailPrefs.enrollEmail": "email@emoryhealthcare.org",
  "emailPrefs.enrollName": "Jina (hiari)",
  "emailPrefs.enroll": "Ongeza mpokeaji",
  "emailPrefs.officerSummaryNote": "Muhtasari wa shughuli za afisa ni ripoti iliyopangwa ya shughuli za skani zilizorekodiwa pamoja na tahadhari zake — si alama ya utendaji, na hautumwi kamwe kwa yeyote ambaye hajajiandikisha.",
  "officerMap.open": "Tazama ramani ya historia ya skani",
  "officerMap.title": "Historia ya Skani",
  "officerMap.loadFailed": "Imeshindwa kupakia historia ya skani",
  "officerMap.empty": "Hakuna skani zenye lebo ya GPS zilizohusishwa na afisa huyu katika kipindi kilichochaguliwa.",
  "officerMap.firstScan": "Skani ya kwanza",
  "officerMap.lastScan": "Skani ya mwisho",
  "officerMap.scans": "skani",
  "officerMap.ofTotal": "kati ya skani {n}",
  "officerMap.note": "Skani zilizohusishwa na afisa huyu pekee ndizo zinazoonekana hapa. Skani zilizofanywa wakati hayupo kazini hazijahusishwa na hazionyeshwi.",
  "patrolReports.officersTableTitle": "Shughuli Zilizorekodiwa kwa Afisa",


  // --- Officer detail page (synced from en.ts) ---
  "officerDetail.allOfficers": "Maofisa Wote",
  "officerDetail.backToOfficers": "Rudi kwa Maofisa",
  "officerDetail.notFound": "Afisa hakupatikana.",
  "officerDetail.loadFailed": "Imeshindwa kupakia afisa",
  "officerDetail.selfEnrolled": "Alijisajili mwenyewe",
  "officerDetail.addedBySupervisor": "Aliongezwa na msimamizi",
  "officerDetail.memberSince": "mwanachama tangu {date}",
  "officerDetail.totalScans": "Jumla ya skani",
  "officerDetail.shifts": "Zamu",
  "officerDetail.activeDays": "Siku zenye shughuli",
  "officerDetail.avgShift": "Wastani / zamu",
  "officerDetail.noShiftsYet": "bado hakuna zamu",
  "officerDetail.scansPerShift": "skani kwa kila zamu",
  "officerDetail.lastActive": "Shughuli ya mwisho",
  "officerDetail.whereScanned": "Mahali {name} Aliposkani",
  "officerDetail.mapToLight": "Badilisha ramani kuwa vigae angavu",
  "officerDetail.mapToDark": "Badilisha ramani kuwa vigae giza",
  "officerDetail.light": "Angavu",
  "officerDetail.dark": "Giza",
  "officerDetail.noGpsScans": "Hakuna skani zenye lebo ya GPS za kuweka kwenye ramani katika siku 30 zilizopita.",
  "officerDetail.scanActivityTitle": "Shughuli za Skani — Siku {n} Zilizopita",
  "officerDetail.noScansInDays": "Hakuna skani zilizorekodiwa katika siku {n} zilizopita.",
  "officerDetail.scanHistory": "Historia ya Skani",
  "officerDetail.searchScans": "Tafuta skani…",
  "officerDetail.colDateTime": "Tarehe na Saa",
  "officerDetail.colLocation": "Mahali",
  "officerDetail.colHospital": "Hospitali",
  "officerDetail.colCoordinates": "Viwianishi",
  "officerDetail.noScansMatch": "Hakuna skani zinazolingana na “{q}”.",
  "officerDetail.showingScans": "Inaonyesha {shown} kati ya skani {total} zilizorekodiwa (siku 30 zilizopita).",
  "officerDetail.timelineRange": "skani {n} · kongwe → mpya zaidi",
  "officerDetail.hoverTimeline": "Weka kishale kwenye mstari wa matukio ili kufuatilia skani",
  "officerDetail.timelineCaption": "Kila nukta ni skani moja, imewekwa kulingana na wakati ilipotokea na kupakwa rangi kutoka bluu-kongwe hadi nyekundu-mpya zaidi. Weka kishale ili kuiangazia kwenye ramani. Hakuna njia inayochorwa kati ya skani — maeneo ya skani yaliyorekodiwa pekee ndiyo yanayoonyeshwa.",


  // --- Scan Map anomaly/misplaced views (synced from en.ts) ---
  "map.officer": "Afisa",
  "map.clearOfficer": "Futa kichujio cha afisa",
  "map.searchOfficer": "Tafuta afisa…",
  "map.misplacedTitle": "Onyesha skani ambazo GPS yake ilianguka zaidi ya kilomita 1 kutoka kituo chake cha ukaguzi pekee",
  "map.misplacedOn": "Zilizowekwa vibaya",
  "map.misplacedOff": "Zilizowekwa vibaya",
  "map.anomaliesTitle": "Onyesha skani zilizowekewa alama kama zisizo za kawaida — usafiri wa afisa usiowezekana, au skani iliyowekwa mbali na hospitali yake yenyewe",
  "map.anomalies": "Zisizo za kawaida",
  "map.popupOfficer": "Afisa:",
  "map.anomalousMovement": "Isiyo ya kawaida — usafiri usiowezekana kati ya skani za afisa huyu",
  "map.anomalousHospital": "Isiyo ya kawaida — imewekwa mbali na hospitali yake iliyoandikwa",
  "map.anomalousBoth": "Isiyo ya kawaida — usafiri usiowezekana na mbali na hospitali yake",
  "map.metersFromCheckpoint": "mita {n} kutoka kituo chake cha ukaguzi",
  "map.scansLabel": "skani",
  "map.earliest": "Ya kwanza kabisa",
  "map.latest": "Ya hivi karibuni",

};

export default sw;
